export default __webpack_public_path__ + "static/media/Slide14.baeb006a.PNG";